import { CancelToken } from 'axios';
import { axiosRequest } from './instance';

export enum MentionType {
  MENTOR = 'MENTOR',
  FOUNDER = 'FOUNDER',
  VENTURE = 'VENTURE',
}

export interface MentionSuggestion {
  id: string;
  displayName: string;
  type: MentionType;
}

export interface MentionSuggestionsDTO {
  suggestions: MentionSuggestion[];
}

export function getMentions(
  search: string,
  cancelToken?: CancelToken,
): Promise<MentionSuggestionsDTO> {
  return axiosRequest
    .get<MentionSuggestionsDTO>({
      url: `/mentions/suggestions?search=${encodeURIComponent(search)}`,
      credentials: true,
      cancelToken,
    })
    .then((r) => r.data);
}

export function getMentorMentions(
  search: string,
  cancelToken?: CancelToken,
): Promise<MentionSuggestionsDTO> {
  return axiosRequest
    .get<MentionSuggestionsDTO>({
      url: `/mentions/suggestions/mentors?search=${encodeURIComponent(search)}`,
      credentials: true,
      cancelToken,
    })
    .then((r) => r.data);
}

export function getFounderMentions(
  search: string,
  cancelToken?: CancelToken,
): Promise<MentionSuggestionsDTO> {
  return axiosRequest
    .get<MentionSuggestionsDTO>({
      url: `/mentions/suggestions/founders?search=${encodeURIComponent(
        search,
      )}`,
      credentials: true,
      cancelToken,
    })
    .then((r) => r.data);
}

export function getVentureMentions(
  search: string,
  cancelToken?: CancelToken,
): Promise<MentionSuggestionsDTO> {
  return axiosRequest
    .get<MentionSuggestionsDTO>({
      url: `/mentions/suggestions/ventures?search=${encodeURIComponent(
        search,
      )}`,
      credentials: true,
      cancelToken,
    })
    .then((r) => r.data);
}
